import { Box } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import Footer from 'components/organisms/Footer/GlobalFooter';
import Header from 'components/organisms/Header/HomeHeader';
import MobileHomeHeader from 'components/organisms/Header/MobileHomeHeader';
import { HomePageProvider } from 'context';
import { selectAuth } from 'features/auth/authSlice';
import { setLoading } from 'features/auth/chatSlice';
import { useEffect, useRef, useState } from 'react';
import Media from 'react-media';
import { useDispatch } from 'react-redux';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { fetchInboxUsers } from 'utils/Firebase.util';
import {
  BackstageBody,
  HomeBody,
  RewardsBody,
} from 'views/DesktopViews/HomePage';
import Explore2 from './Explore2';
import ExplorePage from './ExplorePage';

interface Location {
  state?: {
    from?: {
      pathname?: string;
    };
  };
}

const Home = () => {
  const location = useLocation() as Location;
  const locationRef = useRef<Location>(location);
  const navigate = useNavigate();
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();

  type pageType = {
    home: boolean;
    auction: boolean;
    backstage: boolean;
    rewards: boolean;
  };

  const [, setContentPage] = useState<pageType>({
    home: true,
    auction: false,
    backstage: false,
    rewards: false,
  });

  const isHome = (): void => {
    setContentPage({
      home: true,
      auction: false,
      backstage: false,
      rewards: false,
    });
  };
  const isAuction = (): void => {
    setContentPage({
      home: false,
      auction: true,
      backstage: false,
      rewards: false,
    });
  };
  const isBackstage = (): void => {
    setContentPage({
      home: false,
      auction: false,
      backstage: true,
      rewards: false,
    });
  };
  const isRewards = (): void => {
    setContentPage({
      home: false,
      auction: false,
      backstage: false,
      rewards: true,
    });
  };

  useEffect(() => {
    if (locationRef.current.state?.from?.pathname && authState.authenticated)
      navigate(locationRef.current.state?.from?.pathname, { replace: true });
    //eslint-disable-next-line
  }, [location?.state?.from?.pathname, authState.authenticated]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        await fetchInboxUsers(authState, dispatch, setLoading);
      } catch (error) {
        console.log(error);
      }
    };
    fetchUsers();
    //eslint-disable-next-line
  }, [authState.id]);

  return (
    <>
      <HomePageProvider>
        <Media query="(max-width: 599px)">
          {matches =>
            matches ? (
              <MobileHomeHeader />
            ) : (
              <Header
                Home={isHome}
                Auction={isAuction}
                Backstage={isBackstage}
                Rewards={isRewards}
              />
            )
          }
        </Media>
        <Box>
          <Routes>
            <Route path="/" element={<HomeBody />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/explore2" element={<Explore2 />} />
            <Route
              path="/backstage"
              element={
                <RequireAuth redirectTo="/">
                  <BackstageBody />
                </RequireAuth>
              }
            />
            <Route path="/rewards" element={<RewardsBody />} />
          </Routes>
        </Box>
        <Footer />
      </HomePageProvider>
    </>
  );
};
interface IRequireAuth {
  children: React.ReactChild;
  redirectTo: string;
}
const RequireAuth: React.FC<IRequireAuth> = ({ children, redirectTo }) => {
  const authState = useAppSelector(selectAuth);
  return authState.authenticated ? (
    <> {children} </>
  ) : (
    <Navigate to={redirectTo} />
  );
};
export default Home;
